import PropTypes from 'prop-types';
import React from 'react';
import { Spinner as LibSpinner } from 'react-bootstrap';
import styled, { css } from 'styled-components';

import { theme } from '_constants/theme';

// eslint-disable-next-line react/display-name, react/prop-types, no-unused-vars
const StyledSpinner = styled(({ color, ...props }) => <LibSpinner {...props} />)`
  &.text-custom {
    color: ${theme.colors.gray.secondary};

    ${({ color }) =>
      color &&
      css`
        color: ${color};
      `};
  }
`;

const Spinner = ({ color, ...restProps }) => {
  return <StyledSpinner animation="border" variant="custom" color={color} {...restProps} />;
};

Spinner.propTypes = {
  color: PropTypes.string,
};

export default Spinner;
